import { gatewayInstance } from "../../axiosInstance";

export const addTaxSetup = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "financeservice/tax/setup",
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const searchTax = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "financeservice/tax/search",
      data,
    );
    return response.data !== null ? response.data : [];
  } catch (e) {
    console.error(e);
  }
};

export const taxGetById = async (taxCode) => {
  try {
    const response = await gatewayInstance.post(
      `financeservice/tax/by-id/${taxCode}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
export const updateTax = async (taxCode, data) => {
  try {
    const response = await gatewayInstance.put(
      `financeservice/tax/setup/update/${taxCode}`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const deleteTax = async(taxId) => {
  try{
    const response = await gatewayInstance.delete(
        `financeservice/tax/delete/${taxId}`,
    );
    return response.data;
  }catch (error) {
    console.error(error);
  }
}

export const checkDuplicate = async (taxName, companyId) => {
  try {
    const response = await gatewayInstance.get(
        "financeservice/tax/check/duplicate",
        {
          params: {
            name: taxName,
            companyId: companyId,
          },
        }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }

}